// Three.js Transpiler r180
import { floor, Fn, fract, mul, sub, vec4 } from "three/tsl"

export const mod289 = Fn(([x]: [any]) => {
  return x.sub(floor(x.mul(1.0 / 289.0)).mul(289.0))
})

export const perm = Fn(([x]: [any]) => {
  return mod289(x.mul(34.0).add(1.0).mul(x))
})

export const noise = Fn(([p]: [any]) => {
  const a = floor(p)
  const d = p.sub(a)
  d.assign(d.mul(d).mul(sub(3.0, mul(2.0, d))))
  const b = a.xxyy.add(vec4(0.0, 1.0, 0.0, 1.0))
  const k1 = perm(b.xyxy)
  const k2 = perm(k1.xyxy.add(b.zzww))
  const c = k2.add(a.zzzz)
  const k3 = perm(c)
  const k4 = perm(c.add(1.0))
  const o1 = fract(k3.mul(1.0 / 41.0))
  const o2 = fract(k4.mul(1.0 / 41.0))
  const o3 = o2.mul(d.z).add(o1.mul(sub(1.0, d.z)))
  const o4 = o3.yw.mul(d.x).add(o3.xz.mul(sub(1.0, d.x)))

  return o4.y.mul(d.y).add(o4.x.mul(sub(1.0, d.y)))
})
